export default __webpack_public_path__ + "static/media/veg.a258cb33.png";